
import 'swiper/css/bundle';
import 'swiper/css/effect-fade';
import 'swiper/css/lazy';
import 'swiper/css/mousewheel';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, FreeMode,Mousewheel,Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade, FreeMode,Mousewheel,Lazy]);
import { playIfVideo, pauseVideos } from './SliderHelpers.js'
export default () => ({
    speed: 200,
    swiper: null,
    slidesOffsetBefore: 0,
    loop: false,
    mousewheel:false,

    async init() {

        if(this.$root.hasAttribute('data-mousewheel')){
            this.mousewheel=true;
        }

        this.slidesOffsetBefore = document.body.querySelector('.m-pageTitleTransformer__title').getBoundingClientRect().left;

        const initSwiper = await this.createSwiper()

        // this.swiper.scrollbar.updateSize()
        setTimeout(() => {
            initSwiper.updateSize()
            initSwiper.update()
        }, 900);
        initSwiper.update()
    },

    onWindowResize() { },

    createSwiper() {
        return new Promise((resolve, reject) => {
            const self = this;

            new Swiper(this.$root, {
                updateOnWindowResize: true,
                loop: this.loop,
                direction: 'horizontal',
                spaceBetween: 16,

                //  slidesOffsetAfter:this.slidesOffsetBefore,
                speed: self.speed,
                // effect: 'fade',
                // fadeEffect: {
                //     crossFade: true,
                //   },

                // Navigation arrows
                navigation: {
                    nextEl: self.$refs.next,
                    prevEl: self.$refs.prev,
                },

                preloadImages: false,
                // Enable lazy loading
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount:30
                },

                breakpoints:{

                    1024:{
                        slidesPerView: 'auto',
                        slidesOffsetBefore: this.slidesOffsetBefore,
                        mousewheel: {
                            enabled: this.mousewheel,
                            sensitivity: 1,
                        },
                        spaceBetween: 24,
                        freeMode: {
                            enabled: true,
                            sticky: false,
                            minimumVelocity: 0.4,
                            momentum: true,
                            momentumBounce: false,
                            momentumRatio: .8,
                            momentumVelocityRatio: 1,
                        },
                        effect: '',
                        fadeEffect: { // Add this
                            crossFade: false,
                        },
                    }

                },

                on: {
                    init: function (swiper) {
                        self.swiper = swiper;
                        playIfVideo(swiper);
                        resolve(swiper);
                        swiper.updateSize()
                        swiper.update()
                    },
                    slideChange: function (swiper) {

                        playIfVideo(swiper);
                        swiper.updateSize()
                        swiper.update()
                    },
                    resize(swiper) {
                        swiper.updateSize()
                        swiper.update()
                        // swiper.params.slidesOffsetBefore = document.body.querySelector('#test-content').getBoundingClientRect().left;
                    }
                },
            });


        });

    },

})
